// src/context/AppContext.js
import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function useAppContext() {
  return useContext(AppContext);
}

export function AppProvider({ children }) {
  // Counts for sidebar badges
  const [importCount, setImportCount] = useState(0);
  const [exportCount, setExportCount] = useState(0);
  const [processingExportCount, setProcessingExportCount] = useState(0);
  const [canRecoveryCount, setCanRecoveryCount] = useState(0);
  
  // Master data lists
  const [imports, setImports] = useState([]);
  const [exports, setExports] = useState([]);
  const [products, setProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [assistantDrivers, setAssistantDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const value = {
    importCount, setImportCount,
    exportCount, setExportCount,
    processingExportCount, setProcessingExportCount,
    canRecoveryCount, setCanRecoveryCount,
    imports, setImports,
    exports, setExports,
    products, setProducts,
    suppliers, setSuppliers,
    customers, setCustomers,
    drivers, setDrivers,
    assistantDrivers, setAssistantDrivers,
    vehicles, setVehicles,
    warehouses, setWarehouses,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
